import { Directive } from "@angular/core";

/**
 * Applied automatically to every <input> in the app (this directive is
 * exported from SharedModule, which is imported almost everywhere) so that
 * password managers stop decorating unrelated admin form fields with their
 * autofill icons/prompts.
 *
 * `data-lpignore`/`data-1p-ignore`/`data-bwignore`/`data-dashlane-ignore`
 * cover LastPass/1Password/Bitwarden/Dashlane specifically - they are each
 * extension's own opt-out convention. They do NOT stop the browser's own
 * built-in password manager (e.g. Chrome's saved-logins-for-this-domain
 * dropdown), which instead only respects the standard `autocomplete`
 * attribute - hence also forcing that to "off" here.
 *
 * Opt out on a specific input - e.g. the login page's email/password fields,
 * where autofill is actually wanted - by adding a `data-allow-autofill`
 * attribute to it.
 */
@Directive({
  selector: "input:not([data-allow-autofill])",
  standalone: true,
  host: {
    "data-lpignore": "true",
    "data-1p-ignore": "true",
    "data-bwignore": "true",
    "data-dashlane-ignore": "true",
    "data-form-type": "other",
    autocomplete: "off",
  },
})
export class NoAutofillDirective {}
